import { FC } from 'react';
import { useRouter } from 'next/router';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { Badge } from '@zoopla-eng/zds-components/badges';
import {
    type Taxonomy,
    trackSegmentAndGAEvent,
    EventNames,
} from '@zoopla/tracking';
import AddressSelection, {
    type AddressSelectionSuccessHandler,
} from '../AddressSelection/AddressSelection';
import {
    containerStyle,
    contentStyle,
    formContainerStyle,
} from './PropertyValuationBanner.styles.css';

const DEFAULT_TITLE = 'Book local agents to value your home';

type PropertyValuationBannerProps = {
    title?: string;
    taxonomy: Taxonomy;
};

const PropertyValuationBanner: FC<PropertyValuationBannerProps> = ({
    taxonomy,
    title = DEFAULT_TITLE,
}) => {
    const router = useRouter();

    const handleSuccess: AddressSelectionSuccessHandler = (address) => {
        const { uprn, outcode } = address;

        trackSegmentAndGAEvent(
            EventNames.FIND_AGENTS_VALUATION,
            {
                eventCategory: 'find_agent_valuation',
                eventAction: 'click',
                eventValue: uprn,
            },
            taxonomy.page,
            {
                ...taxonomy,
                uprn,
                outcode,
            }
        );

        router.push(`/valuation/?uprn=${uprn}`);
    };

    return (
        <div className={containerStyle}>
            <div className={contentStyle}>
                <h2 className={fontGroups.mug}>{title}</h2>
                {/* TODO: Make changeable with prop */}
                <p className={fontGroups.ladle}>
                    Get the most accurate valuation based on your unique
                    property features and their in-depth knowledge of the local
                    area.
                </p>
            </div>

            <div>
                <Badge level={4} text="Step 1 of 4" />
                <div className={formContainerStyle}>
                    <AddressSelection
                        id="property-valuation-banner-address"
                        ctaCategory="secondary"
                        onSuccess={handleSuccess}
                        addressCtaOverrides={{
                            text: 'Start my booking',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default PropertyValuationBanner;
